import { title, grayColor} from "assets/jss/material-kit-react.jsx";

const productStyle = {
  section: {
    padding: "70px 0 70px 0",
    '@media (max-width: 900px)': {
      padding: "70px 0 0 0",
    },
    textAlign: "center"
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none"
  },
  description: {
    color: grayColor,
    '@media (max-width: 900px)': {
      marginBottom: 20,
      fontSize: '1.2em',
    },
    marginBottom: 40,
  }
};

export default productStyle;
